export default __webpack_public_path__ + "static/media/lc_cm.7efdebbc.png";